export const PROFILE_LANGUAGES = ["en-US", "de-DE", "es-ES", "fr-FR", "pt-BR", "nl-NL", "da-DK"] as const;

export type ProfileLanguage = (typeof PROFILE_LANGUAGES)[number];

export const DEFAULT_PROFILE_LANGUAGE: ProfileLanguage = "en-US";

export const isProfileLanguage = (value: string): value is ProfileLanguage =>
	(PROFILE_LANGUAGES as readonly string[]).includes(value);

const LANGUAGE_ALIASES: Record<string, ProfileLanguage> = {
	"da-da": "da-DK",
	da: "da-DK",
	en: "en-US",
	de: "de-DE",
	es: "es-ES",
	fr: "fr-FR",
	pt: "pt-BR",
	nl: "nl-NL",
};

const baseLanguageCode = (value: string): string => {
	const lower = value.toLowerCase();
	return lower.split("-", 1)[0] ?? lower;
};

/** Stored value can be a bare code ("de"), legacy Danish ("da-DA"), or an unlisted variant ("en-GB"). */
export const normalizeProfileLanguage = (value: string): ProfileLanguage => {
	const tag = value.trim();
	if (!tag) {
		return DEFAULT_PROFILE_LANGUAGE;
	}
	const lower = tag.toLowerCase();
	const exact = PROFILE_LANGUAGES.find((lang) => lang.toLowerCase() === lower);
	if (exact) {
		return exact;
	}
	const aliased = LANGUAGE_ALIASES[lower] ?? LANGUAGE_ALIASES[baseLanguageCode(tag)];
	if (aliased) {
		return aliased;
	}
	const base = baseLanguageCode(tag);
	return PROFILE_LANGUAGES.find((lang) => baseLanguageCode(lang) === base) ?? DEFAULT_PROFILE_LANGUAGE;
};
